<SidebarShell :logo="short_logo" :brand_title="brand_name" :brand_subtitle="brand_subtitle" :initials="initials"
  :full_name="full_name">
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <template #menu>
    <div class="sidebar-menu-list">
      <template v-for="item in menuItems" :key="item.key">
        <div v-if="item.type === 'accordion'" class="sidebar-menu-group">
          <div class="sidebar-menu-item"
            :class="{ active: (
              (item.key === 'governance-risk-audit' && (is_governance_active || active_menu_item === item.key)) ||
              (item.key === 'impact-exchange-rate-engine' && (is_impact_engine_active || active_menu_item === item.key))
            ), unavailable: !has_dashboard_id(item.key) && !(item.children || []).some(child => has_dashboard_id(child.key)) }" role="button"
            :aria-disabled="!has_dashboard_id(item.key) && !(item.children || []).some(child => has_dashboard_id(child.key))"
            @click="item.key === 'governance-risk-audit' ? toggle_governance() : toggle_impact_engine()">
            <div class="sidebar-menu-main">
              <i :class="item.icon"></i>
              <span v-if="!$root.sidebar_collapsed" class="sidebar-menu-copy">
                <span class="sidebar-menu-text">{{ item.label }}</span>
              </span>
            </div>

            <i v-if="!$root.sidebar_collapsed" class="bi sidebar-menu-chevron"
              :class="(item.key === 'governance-risk-audit' ? governance_open : impact_engine_open) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </div>

          <div
            v-show="(item.key === 'governance-risk-audit' ? governance_open : impact_engine_open) && !$root.sidebar_collapsed"
            class="sidebar-submenu">
            <div v-for="child in item.children" :key="child.key"
              class="sidebar-menu-item"
              :class="{ active: active_menu_item === child.key, unavailable: !has_dashboard_id(child.key) }" role="button"
              :aria-disabled="!has_dashboard_id(child.key)"
              @click.stop="select_menu_item(child.key)">
              <i :class="child.icon"></i>
              <span class="sidebar-menu-copy">
                <span class="sidebar-menu-text">{{ child.label }}</span>
              </span>
            </div>
          </div>
        </div>

        <div v-else class="sidebar-menu-item"
          :class="{ active: active_menu_item === item.key, unavailable: !has_dashboard_id(item.key) }" @click="select_menu_item(item.key)"
          :aria-disabled="!has_dashboard_id(item.key)"
          role="button">
          <i :class="item.icon"></i>
          <span v-if="!$root.sidebar_collapsed" class="sidebar-menu-copy">
            <span class="sidebar-menu-text">{{ item.label }}</span>
          </span>
        </div>
      </template>
    </div>
  </template>
</SidebarShell>
